(function () {
  'use strict';

  const ROOT = document.querySelector('[data-quiz-root]');
  if (!ROOT) return;

  const WEIGHTS = {
    usage: 30,
    sleeping_position: 25,
    concerns: 20,
    firmness: 15,
    budget: 10
  };

  const SCREENS = ['landing', 'q1', 'q2', 'q3', 'q4', 'q5', 'loading', 'error'];
  const QUESTION_SCREENS = ['q1', 'q2', 'q3', 'q4', 'q5'];

  const state = {
    currentScreen: 'landing',
    history: ['landing'],
    answers: {
      usage: null,
      sleeping_position: null,
      concerns: [],
      firmness: null,
      budget: null
    },
    budgetRange: null,
    products: []
  };

  function parseProducts() {
    const raw = ROOT.dataset.products;
    if (!raw) return [];

    return raw.split('||')
      .filter(Boolean)
      .map((entry) => {
        const parts = entry.split('|');
        if (parts.length < 12) return null;

        return {
          id: parts[0],
          handle: parts[1],
          title: parts[2],
          image: parts[3],
          price: parseFloat(parts[4]) || 0,
          usage: (parts[5] || '').split(',').filter(Boolean),
          sleeping_position: (parts[6] || '').split(',').filter(Boolean),
          concerns: (parts[7] || '').split(',').filter(Boolean),
          firmness: parts[8] || '',
          reason_1: parts[9] || '',
          reason_2: parts[10] || '',
          reason_3: parts[11] || ''
        };
      })
      .filter(Boolean);
  }

  function calculateScore(product, answers, budgetRange) {
    if (budgetRange && (product.price < budgetRange.min || product.price > budgetRange.max)) {
      return -1;
    }

    let score = 0;

    if (product.usage.includes(answers.usage)) {
      score += WEIGHTS.usage;
    }

    if (product.sleeping_position.includes(answers.sleeping_position)) {
      score += WEIGHTS.sleeping_position;
    }

    if (answers.concerns.length > 0) {
      const matchedConcerns = answers.concerns.filter((c) => product.concerns.includes(c));
      const concernScore = (matchedConcerns.length / answers.concerns.length) * WEIGHTS.concerns;
      score += concernScore;
    }

    if (product.firmness === answers.firmness) {
      score += WEIGHTS.firmness;
    } else if (isAdjacentFirmness(product.firmness, answers.firmness)) {
      score += WEIGHTS.firmness / 2;
    }

    if (budgetRange) {
      score += WEIGHTS.budget;
    }

    return Math.round(score);
  }

  function isAdjacentFirmness(a, b) {
    const order = ['soft', 'medium', 'firm'];
    const idxA = order.indexOf(a);
    const idxB = order.indexOf(b);
    if (idxA === -1 || idxB === -1) return false;
    return Math.abs(idxA - idxB) === 1;
  }

  function findBestMatch() {
    if (state.products.length === 0) return null;

    const scored = state.products
      .map((p) => ({ product: p, score: calculateScore(p, state.answers, state.budgetRange) }))
      .filter((r) => r.score >= 0)
      .sort((a, b) => b.score - a.score);

    return scored.length > 0 ? scored[0] : null;
  }

  function showScreen(screenName) {
    const allScreens = ROOT.querySelectorAll('[data-screen]');
    allScreens.forEach((s) => s.classList.remove('pq-screen--active'));

    const target = ROOT.querySelector(`[data-screen="${screenName}"]`);
    if (target) {
      target.classList.add('pq-screen--active');
      state.currentScreen = screenName;
      updateProgress();
      window.scrollTo({ top: ROOT.offsetTop - 20, behavior: 'smooth' });
    }
  }

  function updateProgress() {
    const fill = ROOT.querySelector('[data-progress-fill]');
    const current = ROOT.querySelector('[data-step-current]');
    const progressBar = ROOT.querySelector('[data-progress]');

    if (!fill || !current || !progressBar) return;

    const questionIdx = QUESTION_SCREENS.indexOf(state.currentScreen);

    if (questionIdx === -1) {
      progressBar.style.display = ['loading', 'error'].includes(state.currentScreen) ? 'none' : 'flex';
      if (state.currentScreen === 'landing') {
        fill.style.width = '0%';
        current.textContent = '0';
      }
      return;
    }

    progressBar.style.display = 'flex';
    const percent = ((questionIdx + 1) / QUESTION_SCREENS.length) * 100;
    fill.style.width = percent + '%';
    current.textContent = questionIdx + 1;
  }

  function goNext() {
    const idx = SCREENS.indexOf(state.currentScreen);
    if (idx < 0 || idx >= SCREENS.length - 1) return;

    const next = SCREENS[idx + 1];
    if (next === 'loading' || next === 'error') return;

    state.history.push(next);
    showScreen(next);
  }

  function goBack() {
    if (state.history.length <= 1) return;
    state.history.pop();
    const prev = state.history[state.history.length - 1];
    showScreen(prev);
  }

  function handleOptionClick(btn) {
    const screen = btn.closest('[data-screen]');
    const isMulti = screen.dataset.multi === 'true';
    const question = screen.dataset.question;
    const value = btn.dataset.value;

    if (isMulti) {
      btn.classList.toggle('pq-option--selected');

      if (value === 'none') {
        const others = screen.querySelectorAll('.pq-option[data-value]:not([data-value="none"])');
        others.forEach((o) => o.classList.remove('pq-option--selected'));
      } else {
        const noneBtn = screen.querySelector('.pq-option[data-value="none"]');
        if (noneBtn) noneBtn.classList.remove('pq-option--selected');
      }

      const selected = screen.querySelectorAll('.pq-option--selected');
      state.answers.concerns = Array.from(selected).map((el) => el.dataset.value);
    } else {
      const siblings = screen.querySelectorAll('.pq-option');
      siblings.forEach((s) => s.classList.remove('pq-option--selected'));
      btn.classList.add('pq-option--selected');

      if (question === 'budget') {
        state.answers.budget = value;
        state.budgetRange = {
          min: parseFloat(btn.dataset.min),
          max: parseFloat(btn.dataset.max)
        };
      } else {
        state.answers[question] = value;
      }
    }

    const nextBtn = screen.querySelector('[data-action="next"], [data-action="submit"]');
    if (nextBtn) {
      const hasAnswer = isMulti
        ? state.answers.concerns.length > 0
        : state.answers[question] !== null || state.budgetRange !== null;
      nextBtn.disabled = !hasAnswer;
    }
  }

  function handleSubmit() {
    showScreen('loading');
    trackEvent('pillow_quiz_completed', state.answers);

    setTimeout(() => {
      const titleEl = ROOT.querySelector('[data-loading-title]');
      if (titleEl) titleEl.textContent = 'لقينا الخدادية المثالية ليك!';
    }, 1000);

    setTimeout(() => {
      const match = findBestMatch();

      if (!match) {
        showScreen('error');
        trackEvent('pillow_quiz_no_match', state.answers);
        return;
      }

      const params = new URLSearchParams({
        quiz: '1',
        match_score: match.score,
        usage: state.answers.usage || '',
        position: state.answers.sleeping_position || '',
        firmness: state.answers.firmness || ''
      });

      trackEvent('pillow_quiz_recommendation', {
        product_handle: match.product.handle,
        product_id: match.product.id,
        match_score: match.score
      });

      const url = `/products/${match.product.handle}?${params.toString()}`;
      window.location.href = url;
    }, 2500);
  }

  function handleRestart() {
    state.answers = {
      usage: null,
      sleeping_position: null,
      concerns: [],
      firmness: null,
      budget: null
    };
    state.budgetRange = null;
    state.history = ['landing'];

    const allSelected = ROOT.querySelectorAll('.pq-option--selected');
    allSelected.forEach((el) => el.classList.remove('pq-option--selected'));

    const allNextBtns = ROOT.querySelectorAll('[data-action="next"], [data-action="submit"]');
    allNextBtns.forEach((btn) => (btn.disabled = true));

    showScreen('landing');
  }

  function trackEvent(eventName, data) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, data);
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', eventName, data);
      }
    } catch (e) {
      console.warn('Analytics tracking failed:', e);
    }
  }

  function init() {
    state.products = parseProducts();

    if (state.products.length === 0) {
      console.warn('Pillow Quiz: No products with metafields found.');
    }

    ROOT.addEventListener('click', (e) => {
      const optionBtn = e.target.closest('.pq-option');
      if (optionBtn) {
        handleOptionClick(optionBtn);
        return;
      }

      const actionBtn = e.target.closest('[data-action]');
      if (!actionBtn) return;

      const action = actionBtn.dataset.action;

      switch (action) {
        case 'start':
          trackEvent('pillow_quiz_started', {});
          goNext();
          break;
        case 'next':
          goNext();
          break;
        case 'back':
          goBack();
          break;
        case 'submit':
          handleSubmit();
          break;
        case 'restart':
          handleRestart();
          break;
      }
    });

    updateProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();